/* unplugin-vue-components disabled */import { render } from "./files-table.vue?vue&type=template&id=32a74b06&scoped=true"
import script from "./files-table.vue?vue&type=script&lang=js"
export * from "./files-table.vue?vue&type=script&lang=js"

import "./files-table.vue?vue&type=style&index=0&id=32a74b06&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a74b06"],['__file',"src/pages/tenants/files/files-table.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "32a74b06"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('32a74b06', __exports__)) {
    api.reload('32a74b06', __exports__)
  }
  
  module.hot.accept("./files-table.vue?vue&type=template&id=32a74b06&scoped=true", () => {
    api.rerender('32a74b06', render)
  })

}


export default __exports__